/**
 * Assembles the message body sent to HubSpot's hidden `0-1/message` field on
 * Request Quote submission. The sales team reads this to see which equipment
 * the customer designed before reaching out — without it they have to follow
 * up to ask "what did you design?"
 *
 * Format:
 *   Customer requesting a quote for a system designed with Workplace Designer.
 *   [Area Name]:
 *   (qty)-Model Name
 *   (qty)-Model Name
 *   [Area Name]:
 *   ...
 *
 * Non-production builds (dev, stage, local) prepend a TEST_PREFIX so marketing
 * can filter test submissions in HubSpot CRM. Detection is build-time via the
 * REACT_APP_STORAGE_SERVICE_URL env var — both US and EU prod builds point at
 * a `designer-storage-api-prod*` host; dev points at `-dev`, stage at
 * `-staging`. See `deployment/.env.*` for the canonical values.
 */
import { getRequestFromData } from 'reduxModules/ducks/container';

const MESSAGE_HEADER =
  'Customer requesting a quote for a system designed with Workplace Designer.';

const TEST_PREFIX = '[TEST SUBMISSION — non-production environment]';

const isProductionBuild = (): boolean => {
  const storageUrl = process.env.REACT_APP_STORAGE_SERVICE_URL || '';
  // Matches US prod (`-prod`) and EU prod (`-prodeu`); excludes `-dev` and
  // `-staging` builds and any unset env (local dev).
  return /designer-storage-api-prod(eu)?\./.test(storageUrl);
};

export const buildQuoteMessage = (state: any): string => {
  const equipmentLines = (getRequestFromData(state) || []) as string[];
  const lines = [MESSAGE_HEADER, ...equipmentLines];
  if (!isProductionBuild()) {
    lines.unshift(TEST_PREFIX);
  }
  return lines.join('\n');
};
